import { Input } from '@storeblocks/input';
import { type FC } from 'react';

import { useTexts } from '@/hooks/useTexts';

interface Props {
  value: string;
  onChange: (query: string) => void;
}

export const SearchField: FC<Props> = ({ value, onChange }) => {
  const texts = useTexts();

  return (
    <Input
      id="fund-list-search-input"
      name="fund-list-search-input"
      label={texts.orders.form.addFundModal.table.columnTitle.fundName}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      icon={{ name: 'search' }}
      fluid
      autoComplete="off"
    />
  );
};
